module.exports = __webpack_public_path__ + "img/cimb.7fc06848.png";